import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './Date.styles.scss';

const DateInput = ({ name, value, onValueChange, className }) => {
	const [selectedDate, setSelectedDate] = useState(value ? new Date(value) : null);

	useEffect(() => {
		if (!value) return;
		setSelectedDate(new Date(value));
	}, [value]);

	return (
		<div className={`dateInput ${className}`}>
			<ReactDatePicker
				selected={selectedDate}
				placeholderText="Please select"
				onChange={(_date) => {
					setSelectedDate(_date);
					let date = new Date(_date).toISOString().split('T')[0];
					onValueChange({ target: { name, value: date } });
				}}
				dateFormat="dd.MM.yyyy"
			/>
		</div>
	);
};

export default DateInput;
